import React from "react";
import { Table, Button, Form } from "react-bootstrap";

const SempList = ({ plans, onEdit, onDelete, onManageDays, onPublishChange }) => {
  return (
    <Table striped bordered hover responsive="sm">
      <thead>
        <tr>
          <th>#</th>
          <th>제목</th>
          <th>시작일자</th>
          <th>종료일자</th>
          <th>게시 시작</th>
          <th>게시 종료</th>
          <th>운영사이트</th>
          <th>테스트 사이트</th>
          <th>생성자</th>
          <th>최종수정자</th>
          <th>관리</th>
        </tr>
      </thead>
      <tbody>
        {plans.length > 0 ? (
          plans.map((plan) => (
            <tr key={plan.semp_no}>
              <td>{plan.semp_no}</td>
              <td>{plan.semp_title}</td>
              <td>{plan.semp_fdate}</td>
              <td>{plan.semp_tdate}</td>
              <td>{plan.semp_pub_from}</td>
              <td>{plan.semp_pub_to}</td>
              <td>
                <Form.Check 
                  type="switch"
                  id={`use-switch-${plan.semp_no}`}
                  checked={plan.use_yn === 'Y'}
                  onChange={(e) => onPublishChange(plan.semp_no, 'use_yn', e.target.checked)}
                  label={plan.use_yn === 'Y' ? "발행중" : "미발행"}
                />
              </td>
              <td>
                <Form.Check 
                  type="switch"
                  id={`test-switch-${plan.semp_no}`}
                  checked={plan.test_yn === 'Y'}
                  onChange={(e) => onPublishChange(plan.semp_no, 'test_yn', e.target.checked)}
                  label={plan.test_yn === 'Y' ? "발행중" : "미발행"}
                />
              </td>
              <td>{plan.creator_name}</td>
              <td>{plan.changer_name}</td>
              <td>
                <Button
                  variant="outline-info"
                  size="sm"
                  onClick={() => onManageDays(plan)}
                  className="me-2"
                >
                  일정 관리
                </Button>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => onEdit(plan)}
                  className="me-2"
                >
                  수정
                </Button>
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={() => onDelete(plan.semp_no)}
                >
                  삭제
                </Button>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="11" className="text-center">
              데이터가 없습니다.
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};

export default SempList;
